


// import React, { useMemo, useRef, useState } from "react";
// import { Helmet } from "react-helmet-async";
// import { useNavigate } from "react-router-dom";
// import axios from "axios";
// import { toast } from "react-toastify";
// import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
// import "./ReviewForm.scss";
// import PageTitle from "../pagetitle/PageTitle";
// import { useSeo } from "../../hooks/useSeo";

// const initialReviewForm = {
//   name: "",
//   frmName: "Review Form",
//   title: "",
//   email: "",
//   service: "",
//   rating: 0,
//   message: "",
//   reviewImage: null, // single file
// };

// const services = [
//   'Web Development',
//   'App Development',
//   'E-commerce Solution',
//   'Custom Development',
//   'UI/UX Design',
//   'Graphic Design',
//   'Video Editing',
//   'SEO',
//   'SMO'
// ];

// const staticMeta = {
//   title: "Submit a Review | RashTech Info",
//   description: "Share feedback about services from RashTech Info. Your insights help us improve and guide others.",
//   url: "https://rashtechinfo.com/review",
//   image: "https://rashtechinfo.com/og-image.png",
//   siteName: "RashTech Info",
//   keywords: "review, feedback, rating, RashTech Info",
//   themeColor: "#0A0D1C",
// };

// function ReviewForm() {
//   const [form, setForm] = useState(initialReviewForm);
//   const [errors, setErrors] = useState({});
//   const [submitting, setSubmitting] = useState(false);
//   const [submitted, setSubmitted] = useState(false);
//   const [hoverRating, setHoverRating] = useState(0);
//   const fileInputRef = useRef(null);
//   const { executeRecaptcha } = useGoogleReCaptcha();
//   const navigate = useNavigate();

//   const { seo } = useSeo("/getSeo");
//   const computed = useMemo(() => {
//     const dynamic = {
//       title: seo?.title,
//       description: seo?.metaDescription,
//       keywords: seo?.metaKeywords,
//       canonicalUrl: seo?.canonicalUrl,
//     };
//     return {
//       title: dynamic.title || staticMeta.title,
//       description: dynamic.description || staticMeta.description,
//       keywords: dynamic.keywords || staticMeta.keywords,
//       url: dynamic.canonicalUrl || staticMeta.url,
//       image: staticMeta.image,
//       siteName: staticMeta.siteName,
//       themeColor: staticMeta.themeColor,
//     };
//   }, [seo]);

//   const imagePreview = useMemo(() => {
//     if (!form.reviewImage) return "";
//     return URL.createObjectURL(form.reviewImage);
//   }, [form.reviewImage]);

//   const validate = () => {
//     const e = {};
//     if (!form.name.trim()) e.name = "Please enter your name.";
//     if (!form.email.trim()) e.email = "Please enter your email.";
//     else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email))
//       e.email = "Please enter a valid email.";
//     if (!form.title.trim()) e.title = "Please add a short review title.";
//     if (!form.message.trim()) e.message = "Please write your feedback.";
//     if (!form.frmName.trim()) e.frmName = "Missing form name.";
//     if (!form.rating || form.rating < 1) e.rating = "Select a rating.";
//     return e;
//   };

//   const onChange = (e) => {
//     const { name, value } = e.target;
//     setForm((p) => ({ ...p, [name]: value }));
//     setErrors((p) => ({ ...p, [name]: "" }));
//   };

//   const onSelectService = (e) => {
//     setForm((p) => ({ ...p, service: e.target.value }));
//   };

//   const onPickFile = () => fileInputRef.current?.click();

//   const onFileChange = (e) => {
//     const file = e.target.files?.[0];
//     if (file) {
//       if (!/^image\/(png|jpe?g|webp|gif)$/i.test(file.type)) {
//         toast.error("Please upload an image (PNG, JPG, WEBP, GIF).");
//         return;
//       }
//       if (file.size > 4 * 1024 * 1024) {
//         toast.error("Image must be under 4MB.");
//         return;
//       }
//       setForm((p) => ({ ...p, reviewImage: file }));
//     }
//   };

//   const clearImage = () => setForm((p) => ({ ...p, reviewImage: null }));

//   const onDrop = (e) => {
//     e.preventDefault();
//     const file = e.dataTransfer.files?.[0];
//     if (!file) return;
//     if (!/^image\/(png|jpe?g|webp|gif)$/i.test(file.type)) {
//       toast.error("Please upload an image (PNG, JPG, WEBP, GIF).");
//       return;
//     }
//     if (file.size > 4 * 1024 * 1024) {
//       toast.error("Image must be under 4MB.");
//       return;
//     }
//     setForm((p) => ({ ...p, reviewImage: file }));
//   };

//   const onDragOver = (e) => e.preventDefault();

//   const setRating = (val) => {
//     setForm((p) => ({ ...p, rating: val }));
//     setErrors((p) => ({ ...p, rating: "" }));
//   };

//   const onKeyRate = (e) => {
//     if (e.key === "ArrowRight" || e.key === "ArrowUp") {
//       e.preventDefault();
//       setRating(Math.min(5, (form.rating || 0) + 1));
//     }
//     if (e.key === "ArrowLeft" || e.key === "ArrowDown") {
//       e.preventDefault();
//       setRating(Math.max(1, (form.rating || 1) - 1));
//     }
//     if (e.key === "0") {
//       e.preventDefault();
//       setRating(0);
//     }
//     if (e.key >= "1" && e.key <= "5") {
//       e.preventDefault();
//       setRating(Number(e.key));
//     }
//   };

//   const onSubmit = async (e) => {
//     e.preventDefault();
//     const v = validate();
//     if (Object.keys(v).length) {
//       setErrors(v);
//       const first = Object.keys(v)[0];
//       const el = document.querySelector(`[name="${first}"]`);
//       if (el?.scrollIntoView) el.scrollIntoView({ behavior: "smooth", block: "center" });
//       return;
//     }

//     if (!executeRecaptcha) {
//       toast.error("reCAPTCHA not ready. Please retry.");
//       return;
//     }

//     setSubmitting(true);
//     try {
//       const recaptchaToken = await executeRecaptcha("review_submit");
//       const fd = new FormData();
//       fd.append("name", form.name);
//       fd.append("frmName", form.frmName);
//       fd.append("email", form.email);
//       fd.append("title", form.title);
//       fd.append("service", form.service);
//       fd.append("rating", String(form.rating));
//       fd.append("message", form.message);
//       fd.append("recaptchaValue", recaptchaToken);
//       if (form.reviewImage) fd.append("reviewImage", form.reviewImage);

//       const response = await axios.post(
//         `https://api.rashtechinfo.com/submitFeedback`,
//         fd,
//         { headers: { "Content-Type": "multipart/form-data" } }
//       );

//       if (response.status === 200) {
//         toast.success("Thanks! Your review was submitted.");
//         setSubmitted(true);
//         setForm(initialReviewForm);
//         setTimeout(() => setSubmitted(false), 3500);
//       } else {
//         toast.error("Unable to submit the review. Please try later.");
//       }
//     } catch (err) {
//       toast.error("Review submission failed. Please try again.");
//     } finally {
//       setSubmitting(false);
//     }
//   };

//   const handleBack = () => {
//     navigate(-1); // Go back to previous page
//   };

//   return (
//     <>
//       <Helmet>
//         <title>{computed.title}</title>
//         <meta name="description" content={computed.description} />
//         {computed.keywords && <meta name="keywords" content={computed.keywords} />}
//         <meta name="viewport" content="width=device-width, initial-scale=1" />
//         <meta name="theme-color" content={computed.themeColor} />
//         {computed.url && <link rel="canonical" href={computed.url} />}

//         <meta property="og:type" content="website" />
//         <meta property="og:site_name" content={computed.siteName} />
//         <meta property="og:title" content={computed.title} />
//         <meta property="og:description" content={computed.description} />
//         {computed.url && <meta property="og:url" content={computed.url} />}
//         {computed.image && <meta property="og:image" content={computed.image} />}

//         <meta name="twitter:card" content="summary_large_image" />
//         <meta name="twitter:title" content={computed.title} />
//         <meta name="twitter:description" content={computed.description} />
//         {computed.image && <meta name="twitter:image" content={computed.image} />}
//       </Helmet>

//       <main className="page_content about-page">
//         <section className="review-shell">
//           <form className="review-card" onSubmit={onSubmit} noValidate>
//             <header className="review-head">
//               <div className="badge">Feedback</div>
//               <h1 className="title">Share Experience</h1>
//               <p className="subtitle">Tell others about the service received.</p>
//             </header>

//             <div className="grid">
//               {/* Name */}
//               <div className={`field ${errors.name ? "has-error" : ""}`}>
//                 <div className="float-control">
//                   <input
//                     type="text"
//                     name="name"
//                     className="input"
//                     value={form.name}
//                     onChange={onChange}
//                     placeholder=" "
//                     autoComplete="name"
//                   />
//                   <label className="label">Full name</label>
//                 </div>
//                 {errors.name && <span className="hint">{errors.name}</span>}
//               </div>

//               {/* Email */}
//               <div className={`field ${errors.email ? "has-error" : ""}`}>
//                 <div className="float-control">
//                   <input
//                     type="email"
//                     name="email"
//                     className="input"
//                     value={form.email}
//                     onChange={onChange}
//                     placeholder=" "
//                     autoComplete="email"
//                   />
//                   <label className="label">Email</label>
//                 </div>
//                 {errors.email && <span className="hint">{errors.email}</span>}
//               </div>

//               {/* Title */}
//               <div className={`field ${errors.title ? "has-error" : ""}`}>
//                 <div className="float-control">
//                   <input
//                     type="text"
//                     name="title"
//                     className="input"
//                     value={form.title}
//                     onChange={onChange}
//                     placeholder=" "
//                   />
//                   <label className="label">Review title</label>
//                 </div>
//                 {errors.title && <span className="hint">{errors.title}</span>}
//               </div>

//               {/* Service */}
//               <div className="field">
//                 <div className="float-control">
//                   <select
//                     className="input select"
//                     name="service"
//                     value={form.service}
//                     onChange={onSelectService}
//                   >
//                     <option value="">Select service</option>
//                     {services.map((s) => (
//                       <option key={s} value={s}>{s}</option>
//                     ))}
//                   </select>
//                   <label className="label">Service (optional)</label>
//                 </div>
//               </div>

//               {/* Rating */}
//               <div className={`field ${errors.rating ? "has-error" : ""}`}>
//                 <div className="rating">
//                   <span className="rating-label">Rating</span>
//                   <div
//                     className="stars"
//                     role="radiogroup"
//                     aria-label="Star rating"
//                     tabIndex={0}
//                     onKeyDown={onKeyRate}
//                   >
//                     {[1, 2, 3, 4, 5].map((n) => {
//                       const active = hoverRating ? n <= hoverRating : n <= form.rating;
//                       return (
//                         <button
//                           type="button"
//                           key={n}
//                           className={`star ${active ? "active" : ""}`}
//                           aria-label={`${n} star${n > 1 ? "s" : ""}`}
//                           aria-checked={form.rating === n}
//                           role="radio"
//                           onMouseEnter={() => setHoverRating(n)}
//                           onMouseLeave={() => setHoverRating(0)}
//                           onFocus={() => setHoverRating(n)}
//                           onBlur={() => setHoverRating(0)}
//                           onClick={() => setRating(n)}
//                         >
//                           ★
//                         </button>
//                       );
//                     })}
//                   </div>
//                 </div>
//                 {errors.rating && <span className="hint">{errors.rating}</span>}
//               </div>

//               {/* Message */}
//               <div className={`field full ${errors.message ? "has-error" : ""}`}>
//                 <div className="float-control">
//                   <textarea
//                     name="message"
//                     className="input textarea"
//                     rows={5}
//                     value={form.message}
//                     onChange={onChange}
//                     placeholder=" "
//                   />
//                   <label className="label">Your review</label>
//                 </div>
//                 {errors.message && <span className="hint">{errors.message}</span>}
//               </div>

//               {/* Image uploader */}
//               <div className="field full">
//                 <div
//                   className={`dropzone ${form.reviewImage ? "has-file" : ""}`}
//                   onDrop={onDrop}
//                   onDragOver={onDragOver}
//                   onClick={onPickFile}
//                   role="button"
//                   aria-label="Upload image"
//                   tabIndex={0}
//                 >
//                   {!form.reviewImage ? (
//                     <div className="dropzone-inner">
//                       <div className="icon">📷</div>
//                       <div className="dz-text">
//                         <strong>Drag & drop</strong> or click to upload an image
//                       </div>
//                       <div className="dz-sub">PNG, JPG, WEBP, GIF up to 4MB</div>
//                     </div>
//                   ) : (
//                     <div className="preview">
//                       <img src={imagePreview} alt="Preview" />
//                       <button
//                         type="button"
//                         className="remove"
//                         onClick={(e) => {
//                           e.stopPropagation();
//                           clearImage();
//                         }}
//                       >
//                         Remove
//                       </button>
//                     </div>
//                   )}
//                   <input
//                     ref={fileInputRef}
//                     type="file"
//                     accept="image/png,image/jpeg,image/webp,image/gif"
//                     className="hidden-file"
//                     onChange={onFileChange}
//                   />
//                 </div>
//               </div>
//             </div>

//             <footer className="actions">
//               <div className="actions-container">
//                 <button
//                   type="submit"
//                   className="btn primary submit-btn"
//                   disabled={submitting}
//                   aria-busy={submitting}
//                 >
//                   {submitting ? (
//                     <span className="loader">
//                       <span className="dot" />
//                       <span className="dot" />
//                       <span className="dot" />
//                     </span>
//                   ) : (
//                     <>
//                       Submit review <i className="fa-solid fa-arrow-up-right"></i>
//                     </>
//                   )}
//                 </button>
//               </div>

//               <div className="back-btn-container">
//                 <button
//                   type="button"
//                   className="back-btn"
//                   onClick={handleBack}
//                   disabled={submitting}
//                 >
//                   <i className="fa-solid fa-arrow-left"></i> Back
//                 </button>
//               </div>

//               {submitted && <div className="success">Thanks! Review submitted.</div>}
//             </footer>
//           </form>
//         </section>
//       </main>
//     </>
//   );
// }

// export default ReviewForm;


import React, { useMemo, useRef, useState } from "react";
import { Helmet } from "react-helmet-async";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import "./ReviewForm.scss";
import PageTitle from "../pagetitle/PageTitle";
import { useSeo } from "../../hooks/useSeo";

const initialReviewForm = {
  name: "",
  designation: "", // Changed from frmName to designation
  title: "",
  email: "",
  service: "",
  rating: 0,
  message: "",
  reviewImage: null, // single file
};

const services = [
  'Web Development',
  'App Development',
  'E-commerce Solution',
  'Custom Development',
  'UI/UX Design',
  'Graphic Design',
  'Video Editing',
  'SEO',
  'SMO'
];

const staticMeta = {
  title: "Submit a Review | RashTech Info",
  description: "Share feedback about services from RashTech Info. Your insights help us improve and guide others.",
  url: "https://rashtechinfo.com/review",
  image: "https://rashtechinfo.com/og-image.png",
  siteName: "RashTech Info",
  keywords: "review, feedback, rating, RashTech Info",
  themeColor: "#0A0D1C",
};

function ReviewForm() {
  const [form, setForm] = useState(initialReviewForm);
  const [errors, setErrors] = useState({});
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [hoverRating, setHoverRating] = useState(0);
  const fileInputRef = useRef(null);
  const { executeRecaptcha } = useGoogleReCaptcha();
  const navigate = useNavigate();

  const { seo } = useSeo("/getSeo");
  const computed = useMemo(() => {
    const dynamic = {
      title: seo?.title,
      description: seo?.metaDescription,
      keywords: seo?.metaKeywords,
      canonicalUrl: seo?.canonicalUrl,
    };
    return {
      title: dynamic.title || staticMeta.title,
      description: dynamic.description || staticMeta.description,
      keywords: dynamic.keywords || staticMeta.keywords,
      url: dynamic.canonicalUrl || staticMeta.url,
      image: staticMeta.image,
      siteName: staticMeta.siteName,
      themeColor: staticMeta.themeColor,
    };
  }, [seo]);

  const imagePreview = useMemo(() => {
    if (!form.reviewImage) return "";
    return URL.createObjectURL(form.reviewImage);
  }, [form.reviewImage]);

  const validate = () => {
    const e = {};
    if (!form.name.trim()) e.name = "Please enter your name.";
    if (!form.designation.trim()) e.designation = "Please enter your designation."; // Updated validation
    if (!form.email.trim()) e.email = "Please enter your email.";
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email))
      e.email = "Please enter a valid email.";
    if (!form.title.trim()) e.title = "Please add a short review title.";
    if (!form.message.trim()) e.message = "Please write your feedback.";
    if (!form.rating || form.rating < 1) e.rating = "Select a rating.";
    return e;
  };

  const onChange = (e) => {
    const { name, value } = e.target;
    setForm((p) => ({ ...p, [name]: value }));
    setErrors((p) => ({ ...p, [name]: "" }));
  };

  const onSelectService = (e) => {
    setForm((p) => ({ ...p, service: e.target.value }));
  };

  const onPickFile = () => fileInputRef.current?.click();

  const onFileChange = (e) => {
    const file = e.target.files?.[0];
    if (file) {
      if (!/^image\/(png|jpe?g|webp|gif)$/i.test(file.type)) {
        toast.error("Please upload an image (PNG, JPG, WEBP, GIF).");
        return;
      }
      if (file.size > 4 * 1024 * 1024) {
        toast.error("Image must be under 4MB.");
        return;
      }
      setForm((p) => ({ ...p, reviewImage: file }));
    }
  };

  const clearImage = () => setForm((p) => ({ ...p, reviewImage: null }));

  const onDrop = (e) => {
    e.preventDefault();
    const file = e.dataTransfer.files?.[0];
    if (!file) return;
    if (!/^image\/(png|jpe?g|webp|gif)$/i.test(file.type)) {
      toast.error("Please upload an image (PNG, JPG, WEBP, GIF).");
      return;
    }
    if (file.size > 4 * 1024 * 1024) {
      toast.error("Image must be under 4MB.");
      return;
    }
    setForm((p) => ({ ...p, reviewImage: file }));
  };

  const onDragOver = (e) => e.preventDefault();

  const setRating = (val) => {
    setForm((p) => ({ ...p, rating: val }));
    setErrors((p) => ({ ...p, rating: "" }));
  };

  const onKeyRate = (e) => {
    if (e.key === "ArrowRight" || e.key === "ArrowUp") {
      e.preventDefault();
      setRating(Math.min(5, (form.rating || 0) + 1));
    }
    if (e.key === "ArrowLeft" || e.key === "ArrowDown") {
      e.preventDefault();
      setRating(Math.max(1, (form.rating || 1) - 1));
    }
    if (e.key === "0") {
      e.preventDefault();
      setRating(0);
    }
    if (e.key >= "1" && e.key <= "5") {
      e.preventDefault();
      setRating(Number(e.key));
    }
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    const v = validate();
    if (Object.keys(v).length) {
      setErrors(v);
      const first = Object.keys(v)[0];
      const el = document.querySelector(`[name="${first}"]`);
      if (el?.scrollIntoView) el.scrollIntoView({ behavior: "smooth", block: "center" });
      return;
    }

    if (!executeRecaptcha) {
      toast.error("reCAPTCHA not ready. Please retry.");
      return;
    }

    setSubmitting(true);
    try {
      const recaptchaToken = await executeRecaptcha("review_submit");
      const fd = new FormData();
      fd.append("name", form.name);
      fd.append("designation", form.designation); // Updated to designation
      fd.append("email", form.email);
      fd.append("title", form.title);
      fd.append("service", form.service);
      fd.append("rating", String(form.rating));
      fd.append("message", form.message);
      fd.append("recaptchaValue", recaptchaToken);
      if (form.reviewImage) fd.append("reviewImage", form.reviewImage);

      const response = await axios.post(
        `https://api.rashtechinfo.com/submitFeedback`,
        fd,
        { headers: { "Content-Type": "multipart/form-data" } }
      );

      if (response.status === 200) {
        toast.success("Thanks! Your review was submitted.");
        setSubmitted(true);
        setForm(initialReviewForm);
        setTimeout(() => setSubmitted(false), 3500);
      } else {
        toast.error("Unable to submit the review. Please try later.");
      }
    } catch (err) {
      toast.error("Review submission failed. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  const handleBack = () => {
    navigate(-1); // Go back to previous page
  };

  return (
    <>
      <Helmet>
        <title>{computed.title}</title>
        <meta name="description" content={computed.description} />
        {computed.keywords && <meta name="keywords" content={computed.keywords} />}
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta name="theme-color" content={computed.themeColor} />
        {computed.url && <link rel="canonical" href={computed.url} />}

        <meta property="og:type" content="website" />
        <meta property="og:site_name" content={computed.siteName} />
        <meta property="og:title" content={computed.title} />
        <meta property="og:description" content={computed.description} />
        {computed.url && <meta property="og:url" content={computed.url} />}
        {computed.image && <meta property="og:image" content={computed.image} />}

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={computed.title} />
        <meta name="twitter:description" content={computed.description} />
        {computed.image && <meta name="twitter:image" content={computed.image} />}
      </Helmet>

      <main className="page_content about-page">
        <section className="review-shell">
          <form className="review-card" onSubmit={onSubmit} noValidate>
            <header className="review-head">
              <div className="badge">Feedback</div>
              <h1 className="title">Share Experience</h1>
              <p className="subtitle">Tell others about the service received.</p>
            </header>

            <div className="grid">
              {/* Name */}
              <div className={`field ${errors.name ? "has-error" : ""}`}>
                <div className="float-control">
                  <input
                    type="text"
                    name="name"
                    className="input"
                    value={form.name}
                    onChange={onChange}
                    placeholder=" "
                    autoComplete="name"
                  />
                  <label className="label">Full name</label>
                </div>
                {errors.name && <span className="hint">{errors.name}</span>}
              </div>

              {/* Email */}
              <div className={`field ${errors.email ? "has-error" : ""}`}>
                <div className="float-control">
                  <input
                    type="email"
                    name="email"
                    className="input"
                    value={form.email}
                    onChange={onChange}
                    placeholder=" "
                    autoComplete="email"
                  />
                  <label className="label">Email</label>
                </div>
                {errors.email && <span className="hint">{errors.email}</span>}
              </div>

              {/* Designation - New Field */}
              <div className={`field ${errors.designation ? "has-error" : ""}`}>
                <div className="float-control">
                  <input
                    type="text"
                    name="designation"
                    className="input"
                    value={form.designation}
                    onChange={onChange}
                    placeholder=" "
                    autoComplete="organization-title"
                  />
                  <label className="label">Designation</label>
                </div>
                {errors.designation && <span className="hint">{errors.designation}</span>}
              </div>

              {/* Title */}
              <div className={`field ${errors.title ? "has-error" : ""}`}>
                <div className="float-control">
                  <input
                    type="text"
                    name="title"
                    className="input"
                    value={form.title}
                    onChange={onChange}
                    placeholder=" "
                  />
                  <label className="label">Review title</label>
                </div>
                {errors.title && <span className="hint">{errors.title}</span>}
              </div>

              {/* Service */}
              <div className="field">
                <div className="float-control">
                  <select
                    className="input select"
                    name="service"
                    value={form.service}
                    onChange={onSelectService}
                  >
                    <option value="">Select service</option>
                    {services.map((s) => (
                      <option key={s} value={s}>{s}</option>
                    ))}
                  </select>
                  <label className="label">Service (optional)</label>
                </div>
              </div>

              {/* Rating */}
              <div className={`field ${errors.rating ? "has-error" : ""}`}>
                <div className="rating">
                  <span className="rating-label">Rating</span>
                  <div
                    className="stars"
                    role="radiogroup"
                    aria-label="Star rating"
                    tabIndex={0}
                    onKeyDown={onKeyRate}
                  >
                    {[1, 2, 3, 4, 5].map((n) => {
                      const active = hoverRating ? n <= hoverRating : n <= form.rating;
                      return (
                        <button
                          type="button"
                          key={n}
                          className={`star ${active ? "active" : ""}`}
                          aria-label={`${n} star${n > 1 ? "s" : ""}`}
                          aria-checked={form.rating === n}
                          role="radio"
                          onMouseEnter={() => setHoverRating(n)}
                          onMouseLeave={() => setHoverRating(0)}
                          onFocus={() => setHoverRating(n)}
                          onBlur={() => setHoverRating(0)}
                          onClick={() => setRating(n)}
                        >
                          ★
                        </button>
                      );
                    })}
                  </div>
                </div>
                {errors.rating && <span className="hint">{errors.rating}</span>}
              </div>

              {/* Message */}
              <div className={`field full ${errors.message ? "has-error" : ""}`}>
                <div className="float-control">
                  <textarea
                    name="message"
                    className="input textarea"
                    rows={5}
                    value={form.message}
                    onChange={onChange}
                    placeholder=" "
                  />
                  <label className="label">Your review</label>
                </div>
                {errors.message && <span className="hint">{errors.message}</span>}
              </div>

              {/* Image uploader */}
              <div className="field full">
                <div
                  className={`dropzone ${form.reviewImage ? "has-file" : ""}`}
                  onDrop={onDrop}
                  onDragOver={onDragOver}
                  onClick={onPickFile}
                  role="button"
                  aria-label="Upload image"
                  tabIndex={0}
                >
                  {!form.reviewImage ? (
                    <div className="dropzone-inner">
                      <div className="icon">📷</div>
                      <div className="dz-text">
                        <strong>Drag & drop</strong> or click to upload an image
                      </div>
                      <div className="dz-sub">PNG, JPG, WEBP, GIF up to 4MB</div>
                    </div>
                  ) : (
                    <div className="preview">
                      <img src={imagePreview} alt="Preview" />
                      <button
                        type="button"
                        className="remove"
                        onClick={(e) => {
                          e.stopPropagation();
                          clearImage();
                        }}
                      >
                        Remove
                      </button>
                    </div>
                  )}
                  <input
                    ref={fileInputRef}
                    type="file"
                    accept="image/png,image/jpeg,image/webp,image/gif"
                    className="hidden-file"
                    onChange={onFileChange}
                  />
                </div>
              </div>
            </div>

            <footer className="actions">
              <div className="actions-container">
                <button
                  type="submit"
                  className="btn primary submit-btn"
                  disabled={submitting}
                  aria-busy={submitting}
                >
                  {submitting ? (
                    <span className="loader">
                      <span className="dot" />
                      <span className="dot" />
                      <span className="dot" />
                    </span>
                  ) : (
                    <>
                      Submit review <i className="fa-solid fa-arrow-up-right"></i>
                    </>
                  )}
                </button>
              </div>

              <div className="back-btn-container">
                <button
                  type="button"
                  className="back-btn"
                  onClick={handleBack}
                  disabled={submitting}
                >
                  <i className="fa-solid fa-arrow-left"></i> Back
                </button>
              </div>

              {submitted && <div className="success">Thanks! Review submitted.</div>}
            </footer>
          </form>
        </section>
      </main>
    </>
  );
}

export default ReviewForm;